export default __webpack_public_path__ + "static/media/card3.d416472a.jpg";